import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full h-100 about">
      <div className="max-w-screen-lg p-5 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <h3 className="text-4xl font-bold inline border">About</h3>
        </div>
        <p className="text-xl mt-5">
          I'm a MERN Stack Developer, working in both, backend and frontend
          programming. Excited for improving my skills and learning new
          technologies. I'm open to learn and work with any web technology and
          currently doing freelancing.
        </p>
        <br />
        <p className="text-xl">
          I like to code matters from scratch and love the idea of bringing
          thoughts to life. Connect with me to get your project done. <br />{" "}
          <br />
          I value minimalistic designs, thoughtful branding of the content, and
          customer relatable experience. Let's discover together how we can make
          your project convert better!
          <br /> <br />I enjoy creating or redesigning a distinct identity for a
          product or service, get more traffic from search engine and social
          platforms.
        </p>
      </div>
    </div>
  );
};
export default About;